import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=04d4f15b&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=ts&"
export * from "./Users.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4f15b",
  null
  
)

export default component.exports